import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

import { DoctorIncentiveService } from '../../../services/index';
import { AddEditDoctorIncentiveComponent } from './addEditDoctorIncentive.component';

@Component({
    selector: 'doctor-incentive-tab',
    templateUrl: './doctorIncentive.component.html',
})
export class DoctorIncentiveMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    doctorIncentiveData: any[] = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cr.name',
        orderDir: 'asc'
    };

    filterData = { search_data: '' };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(
        private doctorIncentiveService: DoctorIncentiveService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Doctor Name', prop: 'doctor_name', cellClass: 'cell-left', width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Incentive %', prop: 'incentive_percentage', cellClass: 'cell-right', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Start Date', prop: 'start_date', cellClass: 'cell-center', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'End Date', prop: 'end_date', cellClass: 'cell-center', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Status', prop: 'status', cellClass: 'cell-left', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getDoctorIncentiveList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getDoctorIncentiveList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() { $('#filterSearch').focus(); }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getDoctorIncentiveList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getDoctorIncentiveList();
    }

    getDoctorIncentiveList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.doctorIncentiveService
            .getDoctorIncentiveList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.doctorIncentiveData = res.data;
            });
    }

    downloadCurrentData(): void {
        let params = {
            start: '0',
            limit: '99999',
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.doctorIncentiveService.getDoctorIncentiveList(params).then((res: any) => {
            const rows = (res.data || []).map(r => ({
                'DOCTOR NAME':  r.doctor_name,
                'INCENTIVE %':  r.incentive_percentage,
                'START DATE':   r.start_date,
                'END DATE':     r.end_date,
                'STATUS':       r.status
            }));
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'Doctor_Incentive_' + moment().format('DD-MM-YYYY') + '.xlsx');
        });
    }

    bsModalRef: BsModalRef;
    public onAddEditDoctorIncentive(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditDoctorIncentiveComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Doctor Incentive';
        this.bsModalRef.content.doctorIncentiveData = Object.assign({}, row);
        this.bsModalRef.content.doctorIncentiveLoadEvent.subscribe(($e) => {
            that.getDoctorIncentiveList();
        });
    }

    onDeleteDoctorIncentive(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this record Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.doctorIncentiveService
                .deleteDoctorIncentive({ id: row.id })
                .then(function(res: any) {
                    if (res.success) {
                        that.getDoctorIncentiveList();
                        swal('Deleted', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }, function(dismiss) { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctorIncentive/doctorIncentive.component.ts